const manifest = JSON.parse(document.getElementById('theme-component-manifest')?.textContent || '{}');
const pending = new Map();
const desktopMenuQuery = window.matchMedia('(min-width: 750px)');
const modulesByTag = new Map(
  Object.entries(manifest).flatMap(([selector, url]) => selector.split(',').map(tag => [tag, url]))
);
const componentSelector = [...modulesByTag.keys()].join(',');

function loadModule(url) {
  if (!pending.has(url)) {
    pending.set(url, import(url).catch(error => {
      pending.delete(url);
      throw error;
    }));
  }
  return pending.get(url);
}

export async function loadComponents(root = document) {
  if (!componentSelector) return;
  // One subtree query, rather than one query per manifest entry on every mutation.
  const elements = [...root.querySelectorAll(componentSelector)];
  if (root instanceof Element && root.matches(componentSelector)) elements.unshift(root);
  const urls = new Set();
  for (const element of elements) {
    const tag = element.localName;
    if (customElements.get(tag) || (tag === 'header-menu' && !desktopMenuQuery.matches)) continue;
    urls.add(modulesByTag.get(tag));
  }
  await Promise.all([...urls].map(loadModule));
}

function enhance(root) {
  loadComponents(root).catch(error => console.warn('[theme-components] Unable to load controller:', error));
}

enhance(document);
desktopMenuQuery.addEventListener('change', event => {
  if (event.matches) enhance(document);
});

const observer = new MutationObserver(records => {
  const roots = new Set();
  for (const record of records) {
    for (const node of record.addedNodes) {
      if (node instanceof Element && node.isConnected) roots.add(node);
    }
  }
  for (const root of roots) {
    // An inserted parent already covers descendants from this mutation batch.
    let parent = root.parentElement;
    while (parent && !roots.has(parent)) parent = parent.parentElement;
    if (!parent) enhance(root);
  }
});
observer.observe(document.documentElement, { childList: true, subtree: true });
